'use client'

import { useQuery } from '@tanstack/react-query'

import {QueryKey } from 'shared/api'

import { getSaleOrderDetails } from '../api'
import { SaleOrder } from '../types'

export const useQueryPlacedSaleOrder = (token: string, orderId: string) => {
  return useQuery<SaleOrder, unknown, SaleOrder>({
    queryKey: [QueryKey.makedOrder, orderId, token],
    queryFn: async () => {
      const response = await getSaleOrderDetails({ token, id: orderId })

      return response.data.data
    },
    refetchInterval: false, // Disable automatic refetching
    staleTime: 0,
    gcTime: 0,
    enabled: !!token && !!orderId
  })
}
